<app-header></app-header>
<div class="DashmainContainer">
	<form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
		<div class="col-md-12 col-xs-12 font16px mbrshipSection consumer-plan">
			<div class="consumer-plan__head">
				<img src="../../../assets/images/rescuemii-shield.png" alt="RescueMII" class="consumer-plan__shield">
				<h3 class="consumer-plan__title">MEMBERSHIP PLAN</h3>
			</div>

			<div class="consumer-plan__intro" *ngIf="fromSignup">
				<strong>Your account is ready.</strong>
				Your invitation includes the full RescueMII™ membership. Choose a plan below, or continue
				with the free version. RESCUE, 911 and ALARM are always free.
			</div>

			<div *ngFor="let plan of plans; let i = index" class="rdio rdio-primary radio-inline consumer-plan__option">
				<input [id]="'consumer-plan-' + i" type="radio" name="membershipPlan" [value]="plan.code"
					[checked]="selectedPlan?.code === plan.code" (change)="selectPlan(plan)">
				<label [for]="'consumer-plan-' + i">
					<strong>{{ plan.title || 'RescueMII™' }}:</strong> {{ plan.price }}/mo.
				</label>
			</div>
			<div class="invalid-feedback" *ngIf="submitted && form.membershipPlan.errors?.required">
				<span>Please select a plan</span>
			</div>

			<ul class="consumer-plan__features">
				<li><strong>RescueMII™</strong> is handsfree, voice-activated and simple <u>TAP</u> technology.</li>
				<li>When activated, <strong>RESCUE</strong> calls your emergency contacts within seconds.</li>
				<li><strong>HELLO</strong> notifies someone you choose to tell your whereabouts, in the case of an emergency.</li>
				<li><strong>ALARM</strong> is a 90 decibel sounding police alarm, only deactivated by your personal pin code.</li>
				<li><strong>Capture</strong> delivers your photos, recordings and videos to your emergency contacts instantly, just tap.</li>
				<li>TAP 911, Medical, Fire, and Police to connect instantly.</li>
			</ul>

			<div class="consumer-plan__row">
				<input type="checkbox" id="consumerCreditCard" class="consumer-plan__check"
					[checked]="isCardFormOpen" (change)="toggleCardForm()">
				<button type="button" class="btn consumer-plan__button" (click)="toggleCardForm()">Credit Card</button>
			</div>
			<span class="invalid-feedback" *ngIf="submitted && form.creditCard.errors">*Please enter your card details</span>
			<div *ngIf="isCardFormOpen" id="consumer-dropin-container"></div>

			<div class="consumer-plan__row">
				<input class="consumer-plan__check" type="checkbox" formControlName="agreeTandC" id="consumerAgreeTandC">
				<label for="consumerAgreeTandC" class="consumer-plan__terms">
					I agree to the
					<span class="tCtext" (click)="openTerms($event, 'TC')">Terms and Conditions</span>
					and
					<span class="tCtext" (click)="openTerms($event, 'PP')">Privacy Policy</span>
				</label>
			</div>
			<span class="invalid-feedback" *ngIf="submitted && form.agreeTandC.errors">*Please accept the Terms</span>

			<div class="consumer-plan__submit">
				<button type="submit" class="btn consumer-plan__button consumer-plan__button--wide">Submit</button>
			</div>
			<div class="consumer-plan__skip" *ngIf="fromSignup">
				<button type="button" class="btn btn-link" (click)="continueFree()">Continue with the free version</button>
			</div>
		</div>
	</form>
</div>

<button id="consumerFailedBtn" [hidden]="true" data-toggle="modal" data-target="#consumerPaymentFailed">Payment Failed</button>
<div class="modal fade" id="consumerPaymentFailed" tabindex="-1" role="dialog" aria-labelledby="Payment Failed"
	aria-hidden="true" data-backdrop="static" data-keyboard="false">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content confirmationModal">
			<div class="textCenter">
				<img src="../../../assets/images/stop_hand.svg" alt="Payment Failed" class="cnfrmImg">
			</div>
			<div class="martop20px cnfrmMsg text-center">
				<strong [innerHTML]="errorMessage"></strong>
			</div>
			<div class="martop20px cnfrmMsg text-center" *ngIf="errorHasButton">
				<button class="btn btn-primary btn-outline-secondary" type="button" data-dismiss="modal">Retry</button>
			</div>
		</div>
	</div>
</div>

<button id="consumerSuccessBtn" [hidden]="true" data-toggle="modal" data-target="#consumerPaymentSuccess">Payment Success</button>
<div class="modal fade" id="consumerPaymentSuccess" tabindex="-1" role="dialog" aria-labelledby="Payment Success"
	aria-hidden="true" data-backdrop="static" data-keyboard="false">
	<div class="modal-dialog modal-dialog-centered" role="document">
		<div class="modal-content consumer-plan__success">
			<div class="textCenter">
				<h2 class="text-white">WELCOME</h2>
			</div>
			<div class="textCenter consumer-plan__success-body">
				<h5 class="consumer-plan__success-text">{{ successMessage }}</h5>
				<img src="../../../assets/images/download-apple-store.png" alt="App Store" class="appStore"
					(click)="openAppStore()" style="width: 200px" /><br /><br />
				<img src="../../../assets/images/download-google-play.png" alt="Google Play" class="playStore"
					(click)="openPlayStore()" style="width: 200px" />
			</div>
		</div>
	</div>
</div>

<button id="consumerTermsBtn" [hidden]="true" data-toggle="modal" data-target="#consumerTerms">T&C</button>
<div class="modal fade" id="consumerTerms" tabindex="-1" role="dialog" aria-labelledby="Terms and Conditions"
	aria-hidden="true">
	<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
		<div class="modal-content">
			<div class="modal-header col-xs-12 col-md-12 modalTitle">
				<div class="col-md-4 col-xs-4 padnull">
					<img src="" alt="Logo" id="consumerTcLogo" class="tcLogo">
				</div>
				<span class="col-md-4 col-xs-4 textCenter">{{ tcHeader }}</span>
				<div class="col-md-4 col-xs-4" style="text-align: end;">
					<img src="../../../assets/images/cross.svg" data-toggle="modal" data-target="#consumerTerms" (click)="clearTermsUrl()">
				</div>
			</div>
			<div class="modal-body">
				<iframe *ngIf="tcURL" [src]="tcURL" class="tcIFrame"></iframe>
			</div>
		</div>
	</div>
</div>
<app-footer [rescueApp]="true"></app-footer>
